export const currentSchool = window.location.hostname.split(".")[0];

export const setTitle = (hostname) => {
    if (hostname === "localhost") {
        document.title = "Development HiPanda"
    } else if (hostname === 'staging') {
        document.title = "Staging HiPanda"
    }
};